import http from '@/services/http';


async function getTableOrders({ dispatch, rootState, rootGetters }, options = {}) {
  try {
    let response;

    const query = options.query || rootState.session.route;

    const pi = query.partnerIdentification || undefined;

    const userLocationType = rootGetters['orders/userLocationType'];

    if (query.sublocationToken) {
      const args = [`/cardfree-api/v1/pat/pay/${query.sublocationToken}`];

      if (query.orderId) args.push({ params: { oi: query.orderId } });

      response = await http.get(...args);
    }

    else if (query.ticketNumber && query.merchantLocationId) {
      response = await http.get(`/cardfree-api/v1/pat/pay/${query.merchantLocationId}/tickets`, {
        params: {
          pi,
          tn: query.ticketNumber
        }
      });
    }

    else if (query.ticketNumber && query.posLocationId) {
      response = await http.get(`/cardfree-api/v1/pat/pay/${query.posLocationId}/tickets`, {
        params: {
          pi,
          tn: query.ticketNumber,
          isPl: true
        }
      });
    }

    else if (query.tableNumber && query.merchantLocationId) {
      if (query.orderType === 'pat') {
        response = await http.get(`/cardfree-api/v1/pat/pay/${query.merchantLocationId}/tickets`, {
          params: {
            pi,
            t: query.tableNumber
          }
        });
      }
      else {
        /* creates a new Order @ Table order */
        response = await http.post(
          `/cardfree-api/v1/oat/find/${query.merchantLocationId}`,
          null,
          {
            params: {
              beginOrder: true,
              locationType: userLocationType.type,
              tableNumber: query.tableNumber,

              /* add `isOpenTab` query param when location has it enabled */
              isOpenTab: rootGetters['locations/selectedLocation']?.features.OpenTab ? true : undefined
            }
          }
        );
      }
    }

    else if (query.customQuery && query.merchantLocationId) {
      const parsedQueryParams = {};
      const segments = query.customQuery.split(',');

      segments.forEach((segment) => {
        const key = segment.split(':')[0];
        const value = segment.split(':')[1];
        parsedQueryParams[key] = value;
      });

      response = await http.get(`/cardfree-api/v1/pat/pay/${query.merchantLocationId}/tickets`, {
        params: parsedQueryParams
      });
    }

    else {
      return;
    }

    if (response.data.errors) {
      /**
      * NOTE: When CAPI returns an `errors[]` array, the whole response object gets
      * shuffled around with an extra, nesting data param (`response.data.data`). This
      * hack will reformat the response in to the object we expect (all data living
      * directly on `response.data`).
      */

      response.data = {
        ...response.data.data,
        errors: response.data.errors
      };
    }

    const tableOrdersPayload = {
      dontResetIntervalSync: options.dontResetIntervalSync,
      paymentConflict: options.paymentConflict,
      silent: options.silent,
      response
    };

    await dispatch('setTableOrders', tableOrdersPayload);
  }

  catch (error) {
    throw error;
  }
}

export { getTableOrders };

